const DEV_PERSONA_BASE_URL = "https://so96fkx8o9.execute-api.ap-south-1.amazonaws.com/dev";
const DEV_PERSONA_PROXY_BASE = "/persona-api";

export const PERSONA_API_BASE_URL =
  process.env.REACT_APP_PERSONA_API_BASE_URL || DEV_PERSONA_BASE_URL;

const USE_DEV_PROXY =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_PERSONA_USE_DEV_PROXY !== "false";

function toErrorMessage(payload, fallback) {
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  return payload.message || payload.error?.message || fallback;
}

export async function fetchPersonaResult({ clientId, labNo }) {
  const safeClientId = (clientId || "").trim();
  const safeLabNo = (labNo || "").trim();

  if (!safeClientId || !safeLabNo) {
    throw new Error("Both client ID and lab number are required.");
  }

  const params = new URLSearchParams({
    clientId: safeClientId,
    labNo: safeLabNo,
  });

  const baseUrl = USE_DEV_PROXY ? DEV_PERSONA_PROXY_BASE : PERSONA_API_BASE_URL;
  const url = `${baseUrl}/persona?${params.toString()}`;

  let response;
  try {
    response = await fetch(url, {
      method: "GET",
    });
  } catch (networkError) {
    throw new Error("Unable to connect to Persona API. Please check your network and retry.");
  }

  let payload;
  try {
    payload = await response.json();
  } catch (_) {
    throw new Error(`Persona API returned an invalid response (HTTP ${response.status}).`);
  }

  if (!response.ok) {
    throw new Error(toErrorMessage(payload, `Persona request failed (HTTP ${response.status}).`));
  }

  if (!payload || typeof payload !== "object" || !payload.data) {
    throw new Error("Persona API response is missing expected data payload.");
  }

  return payload;
}
